// Site-wide general FAQs rendered as FAQPage schema on the homepage only.
// Service-specific FAQs live in serviceData.js and render on /services/:slug pages.
const HOMEPAGE_FAQS = [
  {
    q: "How much does professional TV mounting cost in Naples, FL?",
    a: "Professional TV mounting in Naples starts at competitive rates and varies based on TV size, wall type, and cable concealment requirements. I.T. Help of SWFL provides free consultations and quotes for all installations, including luxury flush mounts and motorized lifts for high-end homes in Port Royal and Pelican Bay.",
  },
  {
    q: "Do you install smart home systems in Port Royal and luxury estates?",
    a: "Yes. We specialize in white-glove smart home automation for luxury estates in Port Royal, Pelican Bay, Aqualane Shores, and throughout Naples. We integrate UniFi networking, Sonos audio, Honeywell smart thermostats, and Ring security systems for whole-property automation including lighting, climate, security, and entertainment.",
  },
  {
    q: "Can you install entertainment and technology systems on yachts?",
    a: "Absolutely. Our yacht and marine tech service covers smart entertainment systems, weatherproof displays, satellite Wi-Fi, navigation display upgrades, security cameras, and full automation for yachts and marine vessels docked throughout Southwest Florida, including Naples, Marco Island, and Fort Myers.",
  },
  {
    q: "What areas in Southwest Florida do you serve?",
    a: "We serve all of Southwest Florida including Naples, Port Royal, Pelican Bay, Marco Island, Bonita Springs, Fort Myers, Cape Coral, and surrounding areas. We also provide remote IT support nationwide.",
  },
  {
    q: "Are your technicians licensed and insured?",
    a: "Yes, I.T. Help of SWFL is fully licensed and insured. All technicians are background-checked professionals experienced in working within luxury homes, estates, and high-security properties. We are 5-star rated on Google with 89+ verified reviews.",
  },
];

export default HOMEPAGE_FAQS;
